/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const WifiIcon = /*#__PURE__*/ createSvgIcon(
  'WifiIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.01 3.513c-2.95.057-5.878 1.416-7.592 3.87a.51.51 0 11-.836-.585C3.507 4.042 6.76 2.556 9.99 2.493c3.236-.063 6.508 1.303 8.44 4.322a.51.51 0 11-.86.55c-1.709-2.67-4.617-3.91-7.56-3.852zM10 10.985a3.72 3.72 0 00-2.841 1.319.47.47 0 01-.718-.607 4.66 4.66 0 017.118 0 .47.47 0 11-.718.607A3.722 3.722 0 0010 10.985z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 7.32a6.595 6.595 0 00-5.202 2.54.505.505 0 11-.797-.62 7.605 7.605 0 0111.997 0 .505.505 0 11-.796.62A6.595 6.595 0 0010 7.32z"
            fill="currentColor"
          />
          <path
            d="M9.77 17a1.35 1.35 0 100-2.7 1.35 1.35 0 000 2.7z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default WifiIcon;
